module.exports = __webpack_public_path__ + "static/media/pic-complete.37b4d4ce.png";